(() => {
  if (window.toucanDrawerPicksLoaded) return;
  window.toucanDrawerPicksLoaded = true;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-drawer-pick-form]')) return;
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    event.preventDefault();
    if (form.dataset.busy === 'true') return;
    form.dataset.busy = 'true';
    const button = form.querySelector('button[type="submit"]');
    const errorBox = form.querySelector('[data-pick-error]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    errorBox.hidden = true;
    let added = false;
    try {
      const body = new FormData(form);
      const sectionIds = drawer.getSectionsToRender().map(section => section.id);
      body.set('sections', sectionIds.join(','));
      body.set('sections_url', window.location.pathname);
      body.delete('return_to');
      const response = await fetch(form.action + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body
      });
      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Unable to add this item. Please try again.');
      }
      added = true;
      if (!data.sections || sectionIds.some(id => !data.sections[id])) {
        window.location.reload();
        return;
      }
      drawer.renderContents(data);
      const closeButton = drawer.querySelector('.drawer__close');
      if (closeButton) {
        drawer.setActiveElement(document.querySelector('#cart-icon-bubble'));
        window.setTimeout(() => closeButton.focus(), 350);
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'drawer-recommendations', productVariantId: body.get('id') });
      }
    } catch (error) {
      if (added) {
        window.location.reload();
        return;
      }
      errorBox.textContent = error.message;
      errorBox.hidden = false;
    } finally {
      delete form.dataset.busy;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
